import React from 'react'
import Header from '../header/Header.jsx'
function Layout(props) {
  return (
    <>
    <Header />
    {props.children}
    </>
  )
}

export default Layout